import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../static/css/login-register.css";
import { AUTH } from "../utils/Req";
import { RegisterData } from "../utils/Register";
import { ParamsStr } from "../lib/InterfaceCalculation";

const ReqGET = {
  method: "GET"
};
const ReqPOST = {
  method: "POST"
};

// 点过所有的状态的数组。用来记住点过的状态，当前是该数组的最后一个元素。
// 点击页面上的返回的时候，判断这个数组是不是只有当前这一个，如果是，就使用浏览器的 goback()。如果不是，就 pop 出去一个。
// 每次点击下一个状态就 push 进这个数组。

const stateArray = ["MainRegister"];

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerState: RegisterData[`${stateArray[stateArray.length - 1]}`],
      msgOne: "",
      msgTwo: "",
      phone: "",
      password: "",
      passwordType: "password",
      passwordTypeOne: "password",
      passwordOne: "",
      passwordTwo: "",
      agree: true,
      tips: "",
      // 注册成功后也需要一个定时器
      successTimer: 3,
      // 验证码发送成功后，需要添加一个定时器，在该定时器时间内，按钮禁用
      messageCode: "",
      // 小按钮的禁用 （当定时器开启的时候，发送按钮处于禁用状态，到达指定时间后可以重新发送）
      disableSmall: false,
      // 小按钮中显示的字
      sendText: "发送",
      sendTimer: 60
    };

    this.OnkeyDownHandler = this.OnkeyDownHandler.bind(this);
  }

  componentDidMount() {
    this.addOnkeyDownHandler();
  }

  componentWillUnmount() {
    clearInterval(this.sendTimer);
    clearInterval(this.successTimer);
    window.removeEventListener("keydown", this.OnkeyDownHandler);
  }

  goBackHandler() {
    if (stateArray.length <= 1) {
      window.history.back();
    } else {
      stateArray.pop();
      this.setState({
        registerState: RegisterData[`${stateArray[stateArray.length - 1]}`]
      });
    }
  }

  // 添加键盘键入时间
  addOnkeyDownHandler() {
    window.addEventListener("keydown", this.OnkeyDownHandler);
  }

  OnkeyDownHandler(e) {
    if (e.keyCode === 13) {
      document.querySelector(".login-button").focus();
    }
  }

  registerSuccess() {
    const { successTimer } = this.state;
    // 注册成功后五秒返回首页
    this.successTimer = setInterval(() => {
      this.successDoLoop(successTimer);
    }, 1000);
  }

  // 注册成功的倒计时
  successDoLoop(successTimer) {
    let num = this.state.successTimer;
    this.setState({ successTimer: --num });

    if (num <= 0) {
      window.location = `${window.location.pathname}${window.location.search}#/login`;
      clearInterval(this.successTimer);
      this.setState({ successTimer: successTimer });
    }
  }

  // 输入框改变（输入验证也在这里）
  changeInputHandler(e, key) {
    e.preventDefault();

    this.setState({
      [key]: e.target.value
    });
  }

  // onBlur 的逻辑
  onBlurHandler(e, key, inputCount) {
    // 验证数据正则
    const regPhone = /^1[34578]\d{9}$/;
    const regPassword = /^[a-zA-Z0-9]{6,20}$/;
    const regMsgCode = /^\d{6}$/;

    if (key === "phone") {
      if (regPhone.test(e.target.value) === false) {
        // 需要根据输入框的号来渲染错误信息
        if (inputCount === "one") {
          this.setState({ msgOne: "请输入合法的手机号" });
        } else if (inputCount === "two") {
          this.setState({ msgTwo: "请输入合法的手机号" });
        }
      } else {
        this.setState({ msgOne: "", msgTwo: "" });
      }
    }

    if (key === "password" || key === "passwordOne" || key === "passwordTwo") {
      //如果是修改密码等，第二个输入框改变时就要判断输入是否一致
      if (key === "passwordTwo") {
        this.setState({
          msgTwo: e.target.value !== this.state.passwordOne && "两次输入不一致"
        });
      } else {
        this.setState({ msgTwo: "" });
      }
      if (regPassword.test(e.target.value) === false) {
        // 需要根据输入框的号来渲染错误信息
        if (inputCount === "one") {
          this.setState({ msgOne: "6-20位，请使用数字、字母或组合" });
        } else if (inputCount === "two") {
          // 去掉确认密码的情况
          if (key !== "passwordTwo") {
            this.setState({ msgTwo: "6-20位，请使用数字、字母或组合" });
          }
        }
      } else {
        this.setState({ msgOne: "", msgTwo: "" });
      }
    }

    if (key === "messageCode") {
      if (regMsgCode.test(e.target.value) === false) {
        if (inputCount === "one") {
          this.setState({ msgOne: "格式错误" });
        } else if (inputCount === "two") {
          this.setState({ msgTwo: "格式错误" });
        }
      } else {
        this.setState({ msgOne: "", msgTwo: "" });
      }
    }
  }

  // 点击发送(倒计时没有结束不能点击)。调用发送验证码的逻辑
  sendMessageCodeHandler(registerState) {
    const { disableSmall, sendTimer } = this.state;
    if (!disableSmall) {
      this.setState({ disableSmall: true });
      const req = new Request(
        `${AUTH}/reg_verify?phone=${this.state.phone + ParamsStr}`,
        ReqGET
      );

      fetch(req)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.code === 401) {
            this.setState({ disableSmall: false });
            this.tipsMessage("手机号已注册", 2000);
          } else {
            this.tipsMessage("验证码已发送，请稍等...", 2000);
            // 添加倒计时
            this.sendTimer = setInterval(() => {
              // 倒计时完成后，将倒计时数重置为原本的
              this.doLoop(sendTimer);
            }, 1000);
            if (registerState.id === 1) {
              this.changeStateHandler(registerState.buttonText.updateState);
            }
          }
        });
    } else {
      return null;
    }
  }

  // 发送验证码倒计时的逻辑
  doLoop(sendTimer) {
    let num = this.state.sendTimer;

    this.setState({
      sendTimer: --num
    });

    if (num > 0) {
      this.setState({ sendText: `${num}s`, disableSmall: true });
    } else {
      clearInterval(this.sendTimer);
      this.setState({ sendText: "发送", disableSmall: false, sendTimer });
    }
  }

  // 大按钮的点击事件。需要通过判断当前的状态来执行不同的操作
  bigButtonHandler(registerState) {
    // 注册页首页，输入手机号
    if (registerState.id === 1) {
      this.sendMessageCodeHandler(registerState);
    }

    // 快速注册页。点击发送-》发送验证码
    // 点击注册后，验证验证码是否正确。正确就到下一个状态。否则提示用户，验证码错误
    if (registerState.id === 2) {
      const req = new Request(
        `${AUTH}/reg?phone=${this.state.phone}&pw=${this.state.password
        }&vcode=${this.state.messageCode}${ParamsStr}`,
        ReqPOST
      );

      // 这里看不到 response。
      fetch(req)
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          if (data.code === 402) {
            this.tipsMessage("验证码错误", 2000);
          }
          if (data.code === 401) {
            this.tipsMessage("手机号已注册", 2000);
          }
          if (data.code === 200) {
            this.registerSuccess();
            this.changeStateHandler(registerState.buttonText.updateState);
          }
        });
    }

    if (registerState.id === 3) {
      window.location = `${window.location.pathname}${window.location.search}#/`;
    }
  }

  // 状态跳转的逻辑
  changeStateHandler(updateState) {
    console.log("状态跳转");
    stateArray.push(updateState);
    this.setState({
      registerState: RegisterData[`${stateArray[stateArray.length - 1]}`]
    });
  }

  //添加固定秒数的提示
  tipsMessage(text, second) {
    this.setState({ tips: text });
    this.timeout = setTimeout(() => {
      this.setState({ tips: "" });
    }, second);
  }

  render() {
    const {
      msgOne,
      msgTwo,
      registerState,
      successTimer,
      disableSmall,
      sendText
    } = this.state;

    return (
      <div id="register" className="container">
        <div
          className="close"
          onClick={() => {
            this.goBackHandler();
          }}
        />
        <div className="login-container">
          <div className="login-text">{registerState.titleBig}</div>
          {registerState.titleSmall && (
            <div className="register-small-title">
              {registerState.titleSmall}{" "}
              {registerState.hasPhone && this.state.phone}
            </div>
          )}
          {/* 手机号密码登录的时候 第一行需要输入手机号 */}
          {registerState.inputOne &&
            (registerState.inputOne.className === "password" ? (
              <InputPassword
                loginState={registerState}
                value={this.state[registerState.inputOne.id]}
                type={this.state.passwordTypeOne}
                onChange={e => {
                  this.changeInputHandler(e, registerState.inputOne.id);
                }}
                onBlur={e => {
                  this.onBlurHandler(e, registerState.inputOne.id, "one");
                }}
                onClick={() => {
                  this.setState({
                    passwordTypeOne:
                      this.state.passwordTypeOne === "password"
                        ? "text"
                        : "password"
                  });
                }}
              />
            ) : registerState.inputOne.id === "messageCode" ? (
              <div className="input-container">
                <input
                  placeholder={registerState.inputOne.placeholder}
                  className={registerState.inputOne.className}
                  value={this.state[registerState.inputOne.id]}
                  name="message-code"
                  onChange={e => {
                    this.changeInputHandler(e, registerState.inputOne.id);
                  }}
                  onBlur={e => {
                    this.onBlurHandler(e, registerState.inputOne.id, "one");
                  }}
                />
                {registerState.inputOne.id === "messageCode" && (
                  <div
                    className="code-send"
                    style={{
                      backgroundSize: "100%",
                      background:
                        // messageCode &&
                        !disableSmall
                          ? `url(${require("../static/img/login-register/send.png")}) center / 100%`
                          : `url(${require("../static/img/login-register/already-send.png")}) center / 100%`
                    }}
                    disabled={disableSmall}
                    onClick={() => {
                      this.sendMessageCodeHandler(registerState);
                    }}
                  >
                    {sendText}
                  </div>
                )}
                {msgOne && <div className="msg">{msgOne}</div>}
              </div>
            ) : (
                  <InputText
                    loginState={registerState}
                    msgOne={msgOne}
                    value={this.state[registerState.inputOne.id]}
                    onChange={e => {
                      this.changeInputHandler(e, registerState.inputOne.id);
                    }}
                    onBlur={e => {
                      this.onBlurHandler(e, registerState.inputOne.id, "one");
                    }}
                    onClick={() => {
                      this.setState({ [`${registerState.inputOne.id}`]: "" });
                    }}
                  />
                ))}
          {/* 注册页第二个输入框只有密码 */}
          {registerState.inputTwo &&
            (registerState.inputTwo.className === "password" && (
              <InputPassword
                loginState={registerState}
                value={this.state[registerState.inputTwo.id]}
                type={this.state.passwordType}
                msg={msgTwo}
                onChange={e => {
                  this.changeInputHandler(e, registerState.inputTwo.id);
                }}
                onBlur={e => {
                  this.onBlurHandler(e, registerState.inputTwo.id, "two");
                }}
                onClick={() => {
                  this.setState({
                    passwordType:
                      this.state.passwordType === "password"
                        ? "text"
                        : "password"
                  });
                }}
              />
            ))}
          {registerState.success && (
            <div>
              <div className="register-success" />
              <div className="register-success-message">
                {successTimer} 秒后跳转到首页
              </div>
            </div>
          )}
          <button
            className="login-button"
            disabled={
              registerState.inputOne
                ? registerState.inputTwo
                  ? this.state[registerState.inputOne.id] &&
                    this.state[registerState.inputTwo.id] &&
                    !msgOne &&
                    !msgTwo
                    ? false
                    : true
                  : this.state[registerState.inputOne.id] &&
                    this.state.agree &&
                    !msgOne
                    ? false
                    : true
                : false
            }
            style={{
              background: registerState.inputOne
                ? registerState.inputTwo
                  ? this.state[registerState.inputOne.id] &&
                    this.state[registerState.inputTwo.id] &&
                    !msgOne &&
                    !msgTwo
                    ? `url(${require("../static/img/login-register/button-active.png")})`
                    : `url(${require("../static/img/login-register/button.png")})`
                  : this.state[registerState.inputOne.id] &&
                    this.state.agree &&
                    !msgOne
                    ? `url(${require("../static/img/login-register/button-active.png")})`
                    : `url(${require("../static/img/login-register/button.png")})`
                : `url(${require("../static/img/login-register/button-active.png")})`
            }}
            onClick={() => {
              this.bigButtonHandler(registerState);
            }}
          >
            {registerState.buttonText.content}
          </button>
          {this.state.tips && <div className="tips">{this.state.tips}</div>}
          {registerState.statement && (
            <div className="statement-container">
              <div
                className="statement-checkbox"
                onClick={() => {
                  this.setState({
                    agree: this.state.agree === true ? false : true
                  });
                }}
                style={{
                  background: this.state.agree
                    ? `url(${require("../static/img/login-register/agree.png")}) no-repeat`
                    : `url(${require("../static/img/login-register/no-agree.png")}) no-repeat`,
                  backgroundSize: "100%"
                }}
              />
              <div className="statement-content">
                我已阅读并同意
                <a href="http://m.putaoabc.com/pages/userProtocol.html">
                  《用户协议》
                </a>
                与
                <a href="http://m.putaoabc.com/pages/privacy.html">
                  《隐私协议》
                </a>
              </div>
            </div>
          )}
          {registerState.tips && (
            <div className={registerState.tips.className}>
              {registerState.tips.one && (
                <button
                  className="code"
                  onClick={() => {
                    this.setState({
                      registerState:
                        RegisterData[`${registerState.tips.one.updateState}`]
                    });
                  }}
                >
                  {registerState.tips.one.content}
                </button>
              )}
              {registerState.tips.two && (
                <button
                  className="forget"
                  onClick={() => {
                    this.setState({
                      registerState:
                        RegisterData[`${registerState.tips.two.updateState}`]
                    });
                  }}
                >
                  {registerState.tips.two.content}
                </button>
              )}
            </div>
          )}

          <Link to="/login">
            <div className="to-login">去登录</div>
          </Link>
        </div>
        {registerState.signWith && (
          <div className="login-with">
            <div className="login-with-content">
              <div className="line" />
              <div className="login-with-content-text">第三方账号登录</div>
              <div className="line" />
            </div>
            <Link to="/login/weixinLogin">
              <div className="login-with-logo" />
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default Register;

const InputText = ({
  loginState,
  onChange,
  onClick,
  msgOne,
  value,
  onBlur
}) => {
  return (
    <div className="input-container">
      <input
        placeholder={loginState.inputOne.placeholder}
        className={loginState.inputOne.className}
        value={value}
        name="phone"
        type="text"
        onChange={onChange}
        onBlur={onBlur}
      />
      {value && <div className="delete" onClick={onClick} />}
      {msgOne && <div className="msg">{msgOne}</div>}
    </div>
  );
};

const InputPassword = ({
  loginState,
  onChange,
  onClick,
  msg,
  value,
  type,
  onBlur
}) => {
  return (
    <div className="input-container">
      <input
        placeholder={loginState.inputTwo.placeholder}
        className={loginState.inputTwo.className}
        value={value}
        type={type}
        name="password"
        onChange={onChange}
        onBlur={onBlur}
      />
      {value && (
        <div
          className="eyes"
          style={{
            top: type === "password" ? "15px" : "10px",
            background:
              type === "password"
                ? `url(${require("../static/img/login-register/close-eyes.png")}) no-repeat 0 0 / 100%`
                : `url(${require("../static/img/login-register/open-eyes.png")}) no-repeat 0 0 / 100%`,
            backgroundSize: "100%"
          }}
          onClick={onClick}
        />
      )}
      {msg && <div className="msg">{msg}</div>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/route/Register.js